(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wtd-promo-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wtd-promotion-carousel')) {
  customElements.define('wtd-promotion-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      this.dataset.enhanced = 'true';
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.active = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches || Boolean(this.querySelector('[data-signup-success],.wtd-promo-error'));
      this.hovered = false;
      this.toggle = this.querySelector('[data-toggle]');
      this.querySelector('.wtd-promo-controls').hidden = this.slides.length < 2;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index, true));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.slides.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.slides.length) % this.slides.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.slides.length - 1;
          if (next === undefined) return;
          event.preventDefault(); this.select(next, true); this.tabs[next].focus();
        });
      });
      this.querySelector('[data-prev]').addEventListener('click', () => this.select((this.active - 1 + this.slides.length) % this.slides.length, true));
      this.querySelector('[data-next]').addEventListener('click', () => this.select((this.active + 1) % this.slides.length, true));
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.updateToggle(); });
      this.addEventListener('pointerenter', () => { this.hovered = true; });
      this.addEventListener('pointerleave', () => { this.hovered = false; });
      this.addEventListener('focusin', event => { if (event.target.closest('input,.wtd-promo-form')) { this.paused = true; this.updateToggle(); } });
      this.onBlockSelect = event => { const index = this.slides.findIndex(slide => slide.id === 'PromoPanel-' + event.detail.blockId); if (index >= 0) this.select(index, true); };
      this.onMotionChange = () => { if (this.reduced.matches) { this.paused = true; this.updateToggle(); } };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.reduced.addEventListener('change', this.onMotionChange);
      this.select(0);
      this.timer = setInterval(() => {
        if (this.paused || this.hovered || document.hidden || !this.getClientRects().length || this.contains(document.activeElement) || this.slides.length < 2) return;
        this.select((this.active + 1) % this.slides.length);
      }, Number(this.dataset.interval) || 9000);
    }
    select(index, manual = false) {
      this.active = index;
      if (manual) this.paused = true;
      this.slides.forEach((slide, i) => { slide.hidden = i !== index; });
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.updateToggle();
    }
    updateToggle() {
      this.toggle.textContent = this.paused ? '▶' : 'Ⅱ';
      this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.querySelector('.wtd-promo-carousel__slides').setAttribute('aria-live', this.paused ? 'polite' : 'off');
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.reduced) this.reduced.removeEventListener('change', this.onMotionChange);
      delete this.dataset.enhanced;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wtd-radio-rental"]) return;
  try {
    
(() => {
 const form = document.getElementById('RentalQuoteForm');
 if (!form) return;
 const toggle = (container, visible) => {if (!container) return;container.hidden = !visible;container.querySelectorAll('input,textarea,select').forEach(input => input.disabled = !visible);};
 const existing = form.querySelector('#rent-existing_radios');
 const hazard = form.querySelector('#rent-hazardous');
 const accessories = Array.from(form.querySelectorAll('.rental-checks input'));
 const update = () => {
  toggle(form.querySelector('#rent-existing_details')?.parentElement, !!existing?.value && !existing.value.startsWith('No —'));
  toggle(form.querySelector('[data-hazard-details]'), !!hazard?.value && hazard.value !== 'No');
  toggle(form.querySelector('#rent-accessory_quantities')?.parentElement, accessories.some(input => input.checked));
  const hint = hazard?.parentElement.querySelector('small');if(hint) hint.hidden = !hazard.value || hazard.value === 'No';
 };
 form.addEventListener('change',update);update();
 const start = form.querySelector('#rent-start_date');
 const end = form.querySelector('#rent-end_date');
 if (!start || !end) return;
 const now = new Date();
 const today = new Date(now.getTime()-now.getTimezoneOffset()*60000).toISOString().slice(0,10);
 start.min = today; end.min = today;
 start.addEventListener('change', () => {end.min = start.value || today;});
})();

  } catch(e) { console.error(e); }
})();
})();
